const Tag = (props) => {
  return (
    <button className="tag" onClick={props.onClick}>
      {props.children}
    </button>
  );
};

export default Tag;
